import { environment } from '../../../environments/environment';

export const BASE_API_URL = environment.serverUrl + 'api/';
export const PATIENT_SIGNALR_URL = environment.serverUrl + 'NotificationHub/';
export const SUPERSET_URL = environment.superSetUrl;

export const API_ROOT_PATH = {
    APPROVAL: 'approval',
    CONFIGURATION: 'configuration',
    NETWORK_PROVIDER: 'networkprovider',
    INSURANCE_COMPANY: 'insurancepolicy',
    CONTRACT_MANAGEMENT: 'contractmanagement',
    BENEFICIARY: 'beneficiary',
    AUTHENTICATION: 'authentication',
    ELIGIBILITY: 'eligibility',
    PAYMENT_RECONCILIATION: 'paymentreconciliation',
    COMMON: 'common',
    NPHIES: 'nphies',
    ERP: 'erpintegration/consumer'
};

export const API = {
    APPROVAL: {
        APPROVAL: API_ROOT_PATH.APPROVAL + '/approval',
        ASSIGNMENTS: API_ROOT_PATH.APPROVAL + '/assignments',
        ADJUDICATE: API_ROOT_PATH.APPROVAL + '/adjudication',
        UPDATE_STATUS: API_ROOT_PATH.APPROVAL + '/approvalprocess',
        SUBMIT: API_ROOT_PATH.APPROVAL + '/submit',
        PBM_REQUEST: API_ROOT_PATH.APPROVAL + '/approval/pbmrequest',
        PBM_OVERRIDE: API_ROOT_PATH.APPROVAL + '/approval/pbmoverrriderequest',
        MRE: API_ROOT_PATH.APPROVAL + '/mrerequest',
        APPROVAL_ATTACHMENT: API_ROOT_PATH.APPROVAL + '/approvalAttachment',
        DOWNLOAD_APPROVAL_ATTACHMENTS: API_ROOT_PATH.APPROVAL + '/attachments',
        SEND_MAIL: API_ROOT_PATH.APPROVAL + '/sendemailwithapprovalpdf',
    },
    PRE_AUTH: {
        GENERATE_PRE_AUTH_DOC: API_ROOT_PATH.APPROVAL + '/generatepreauthdocumenttopdf',
        PRICELIST_FOR_APPROVAL: API_ROOT_PATH.APPROVAL + '/approval/pricelistforapprovalitem',
        DELETE_UPLOAD: API_ROOT_PATH.APPROVAL + '/upload',
        MARK_READ_PROCESSED: API_ROOT_PATH.APPROVAL + '/claimtransaction/claim/markread',
        UNREAD_PREAUTH_LIST: API_ROOT_PATH.APPROVAL + '/preauth/transaction/unread/count',
        AUTO_ASSIGNMENT: API_ROOT_PATH.APPROVAL + '/autoassignmultipleapprovals',
        ADVANCE_PREAUTH: {
            SENT_TO_NPHIES: API_ROOT_PATH.NPHIES + '/advancepreauth/sendtonphies',
        },
        NEXT_ADJUDICATION_APPROVAL: API_ROOT_PATH.APPROVAL + '/nextadjudicationapproval',
        APPROVAL_SLA: API_ROOT_PATH.APPROVAL + '/adjudicationtime',
        REVIEW_DECISION: API_ROOT_PATH.APPROVAL + '/preauth/reviewerdecision',
        CHANGE_REVIEWER: API_ROOT_PATH.APPROVAL + '/preauth/assignmentreviewer',
    },
    CLAIM: {
        CLAIM: API_ROOT_PATH.APPROVAL + '/claim',
        CLAIMS: API_ROOT_PATH.APPROVAL + '/claims',
        CLAIMS_ALL: API_ROOT_PATH.APPROVAL + '/claimsall',
        ATTACHMENT: API_ROOT_PATH.APPROVAL + '/claim/attachment',
        CLAIM_LIST: API_ROOT_PATH.APPROVAL + '/claimlist',
        UNREAD_CLAIM: API_ROOT_PATH.APPROVAL + '/claimtransaction/claim/unread/count',
        UPLOAD_LIST: API_ROOT_PATH.APPROVAL + '/claimuploadlist',
        UPLOAD_DETAILS_LIST: API_ROOT_PATH.APPROVAL + '/claimuploaddetailslist',
        REVALIDATE_ALL: API_ROOT_PATH.APPROVAL + '/validateclaimall',
        REVALIDATE_CLAIM: API_ROOT_PATH.APPROVAL + '/validateclaim',
        CLAIM_STATICTICS: API_ROOT_PATH.APPROVAL + '/claimuploadstatisticsdetails',
        UPLOAD_CLAIM: {
            DOWNLOAD_TEMPLATE: API_ROOT_PATH.APPROVAL + '/exporttemplate/claims',
            UPLOAD_TEMPLATE: API_ROOT_PATH.APPROVAL + '/bulkimport/claims',
        },
        GENERATE_CLAIM_DOC: API_ROOT_PATH.APPROVAL + '/generateclaimdocumenttopdf',
        ACTIVATE: API_ROOT_PATH.APPROVAL + '/claim/activate',
        UPLOAD_HISTORY_LIST: API_ROOT_PATH.APPROVAL + '/claimuploadhistorylist',
        UPLOAD_HISTORY_STATISTICS: API_ROOT_PATH.APPROVAL + '/claimuploadhistorystatisticsdetails',
        UPLOAD_HISTORY_DETAILS_LIST: API_ROOT_PATH.APPROVAL + '/claimuploadhistorydetailslist',
        UPLOAD_HISTORY_SUMMARY_LIST: API_ROOT_PATH.APPROVAL + '/claimuploadhistoryerrorsummarylist',
        CLAIM_ERROR: API_ROOT_PATH.APPROVAL + '/claimerror',
        BATCH: API_ROOT_PATH.APPROVAL + '/batch',
        PROVIDER_BATCH: API_ROOT_PATH.APPROVAL + '/providerbatch',
        BATCH_PROCESS: API_ROOT_PATH.APPROVAL + '/approvalbatchprocess',
        PRESCRIBED_MEDICATION_DETAILS: API_ROOT_PATH.APPROVAL + '/claim/prescribedmedicationdetails'
    },
    CLAIM_REIMBURSEMENT: {
        CLAIM_REIMBURSEMENT: API_ROOT_PATH.APPROVAL + '/claimreimbursement',
        ATTACHMENT: API_ROOT_PATH.APPROVAL + '/claimreimbursementattachment',
        GETATTACHMENT: API_ROOT_PATH.APPROVAL + '/claimreimbursement/attachment',
        PROCESS: API_ROOT_PATH.APPROVAL + '/claimreimbursementprocess',
        EMAIL: API_ROOT_PATH.APPROVAL + '/sendemailwithclaimreimbursementpdf',
        DOWNLOAD: API_ROOT_PATH.APPROVAL + '/generateclaimreimbursementdocumenttopdf'
    },
    PRESCRIPTION: {
        ATTACHMENT: API_ROOT_PATH.APPROVAL + '/prescription/attachment',
        DOWNLOAD_ATTACHMENT: API_ROOT_PATH.APPROVAL + '/prescription/attachment/download',
        GENERATE_PRESCRIPTION_DOC: API_ROOT_PATH.APPROVAL + '/generateprescriptiondocumenttopdf',
        COMMUNICATION: API_ROOT_PATH.APPROVAL + '/prescription/communication',
        UNREAD_PRESCRIPTION_COMMUNICATION: API_ROOT_PATH.APPROVAL + '/prescription/communication/unread/count',
        MARK_READ_PRESCRIPTION: API_ROOT_PATH.APPROVAL + '/prescriptiontransaction/communication/markread',
        UNREAD_PRESCRIPTION_LIST: API_ROOT_PATH.APPROVAL + '/prescription/transaction/unread/count',
        PBM_REQUEST: API_ROOT_PATH.APPROVAL + '/prescription/pbmrequest',
        PBM: API_ROOT_PATH.APPROVAL + '/prescription/pbm',
    },
    PREAUTH_TO_CLAIM: {
        PREPARE_CLAIM: API_ROOT_PATH.APPROVAL + '/prepareclaimlist',
        PREAUTH_TO_CLAIM: API_ROOT_PATH.APPROVAL + '/convertpreauthtoclaimlist',
        CONVERT_CLAIM: API_ROOT_PATH.APPROVAL + '/convertpreauthtoclaim',
        ADD: API_ROOT_PATH.APPROVAL + '/prepareclaim',
        PREAUTH_TO_CLAIM_SUMMARY: API_ROOT_PATH.APPROVAL + '/convertpreauthtoclaimsummary'
    },
    PAYMENT_RECONCILIATION: {
        PAYMENT_RECONCILIATION: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliation',
        PAYMENT_ERP_TRANSACTION: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/erppaymenttransaction',
        RECONCILATION_ERP_TRANSACTION: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/erpreconciliationpayment',
        LIST: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliationlist',
        PROCESS: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliationprocess',
        UNREAD: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliation/unread/count',
        MARK_ALL_READ: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliation/markread',
        UPDATE_DISCOUNT: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliationdiscount',
        GENERATE_PDF: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/generatepaymentreconciliationtopdf',
        SEND_EMAIL: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/sendemailwithpaymentreconciliationpdf',
        ATTACHMENT: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentattachment/download',
    },
    COMMUNICATION: {
        COMMUNICATION: API_ROOT_PATH.APPROVAL + '/communication',
        NOTE: API_ROOT_PATH.APPROVAL + '/communication/note',
        COMMUNICATION_NOTIFICATION_LIST: API_ROOT_PATH.APPROVAL + '/communicationlist',
        COMMUNICATION_LIST: API_ROOT_PATH.APPROVAL + '/approval/communicationlist',
        MARK_AS_READ: API_ROOT_PATH.APPROVAL + '/communication/markread',
        UNREAD_COUNT: API_ROOT_PATH.APPROVAL + '/communication/unread/count'
    },
    MASTERDATA: {
        COUNTRIES: API_ROOT_PATH.CONFIGURATION + '/country',
        STATE: API_ROOT_PATH.CONFIGURATION + '/state',
        CITY: API_ROOT_PATH.CONFIGURATION + '/city',
        CATEGORY: API_ROOT_PATH.CONFIGURATION + '/category',
        CATEGORIES: API_ROOT_PATH.CONFIGURATION + '/categories',
        UNITTYPE: API_ROOT_PATH.CONFIGURATION + '/unittype',
        EXPORT_UNITTYPE: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/unittype',
        IMPORT_UNITTYPE: API_ROOT_PATH.CONFIGURATION + '/bulkimport/unittype',
        ENTITY: API_ROOT_PATH.CONFIGURATION + '/entity',
        EXPORT_TEMPLATE: API_ROOT_PATH.CONFIGURATION + '/exporttemplate',
        EXPORT_CITY_TEMPLATE: API_ROOT_PATH.CONFIGURATION + '/exporttemplatecity',
        EXPORT_STATE_TEMPLATE: API_ROOT_PATH.CONFIGURATION + '/exporttemplatestate',
        BULK_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport',
        BULK_CITY_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimportcity',
        BULK_STATE_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimportstate',
        COMMONLOV: API_ROOT_PATH.CONFIGURATION + '/commonlov',
        SERVICE_CODE: API_ROOT_PATH.CONFIGURATION + '/servicecode',
        SERVICE_CODE_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/servicecode'
    },
    NETWORK: {
        GET_NETWORK: API_ROOT_PATH.NETWORK_PROVIDER + '/networklist',
    },
    POLICY: {
        POLICY_CLASS: API_ROOT_PATH.INSURANCE_COMPANY + '/policyclass',
        POLICY_CLASS_EXISTS: API_ROOT_PATH.INSURANCE_COMPANY + '/policyclassexists',
        EXPORT_TEMPLATE_POLICY_CLASS: API_ROOT_PATH.INSURANCE_COMPANY + '/exporttemplate/policyclass',
        SUBCOVERAGES: API_ROOT_PATH.INSURANCE_COMPANY + '/subcoverage',
        SEND_EMAIL: API_ROOT_PATH.INSURANCE_COMPANY + '/sendemailwithpolicypdf',
        GENERATE_PDF: API_ROOT_PATH.INSURANCE_COMPANY + '/generatepolicydocumenttopdf',
        BENEFIT: API_ROOT_PATH.INSURANCE_COMPANY + '/benefit',
        BULK_EXPORT_BENEFIT: API_ROOT_PATH.INSURANCE_COMPANY + '/exporttemplate/benefit',
        BULK_IMPORT: API_ROOT_PATH.INSURANCE_COMPANY + '/bulkimport'
    },
    MEDICAL_DEVICE: {
        LIST: API_ROOT_PATH.CONFIGURATION + '/medicaldevicelist',
        CREATE: API_ROOT_PATH.CONFIGURATION + '/medicaldevice',
        SAMPLE_DOWNLOAD: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/medicaldevice',
        BULK_UPLOAD: API_ROOT_PATH.CONFIGURATION + '/bulkimport/medicaldevice'
    },
    CONTRACT: {
        CONTRACT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/contract',
        CONTRACTS: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/contractlist',
        ATTACHMENTS: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/contract/attachments',
        ATTACHMENT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/attachment',
        CONTRACT_DOWNLOAD: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/generatecontractdocumenttopdf',
        EMAIL: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/sendemailwithcontractpdf',
        DOWNLOAD: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/attachment/download',
        BULK_EXPORT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/exporttemplate/contract',
        BULK_IMPORT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/bulkimport/contract',
        BULK_MEDICAL_EXPORT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/exporttemplate/contractmedicalcontact',
        BULK_MEDICAL_IMPORT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/bulkimport/contractmedicalcontact',
        BULK_ADMINSTRATION_EXPORT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/exporttemplate/contractadministrationcontact',
        BULK_ADMINSTRATION_IMPORT: API_ROOT_PATH.CONTRACT_MANAGEMENT + '/bulkimport/contractadministrationcontact',
        NETWORKS: API_ROOT_PATH.NETWORK_PROVIDER + '/network',
        BULK_NETWORK_IMPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/bulkimport/network',
        PRICELIST: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/pricelists',
            CREATE: API_ROOT_PATH.CONFIGURATION + '/pricelist',
            UPDATE: API_ROOT_PATH.CONFIGURATION + '/pricelist',
            DELETE: API_ROOT_PATH.CONFIGURATION + '/pricelist',
            BULK_EXPORT: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/pricelist',
            BULK_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/pricelist',
        }
    },
    NOTIFICATION: {
        PATIENT_NOTIFICATION: API_ROOT_PATH.APPROVAL + '/patientnotification',
        PAYER_NOTIFICATION: API_ROOT_PATH.APPROVAL + '/payernotification',
        PROVIDER_NOTIFICATION: API_ROOT_PATH.APPROVAL + '/providernotification',
    },
    BENEFICIARY: {
        BENEFICIARY: API_ROOT_PATH.BENEFICIARY + '/beneficiary',
        BULK_EXPORT: API_ROOT_PATH.BENEFICIARY + '/exporttemplate/beneficiary',
        BULK_IMPORT: API_ROOT_PATH.BENEFICIARY + '/bulkimport/beneficiary'
    },
    INSURANCE_COMPANY: {
        GET_INSURANCE_LIST: API_ROOT_PATH.INSURANCE_COMPANY + '/insurancecompanylist',
        ADD_INSURANCE: API_ROOT_PATH.INSURANCE_COMPANY + '/insurancecompany',
        BULK_EXPORT: API_ROOT_PATH.INSURANCE_COMPANY + '/exporttemplate/insurancecompany',
        BULK_IMPORT: API_ROOT_PATH.INSURANCE_COMPANY + '/bulkimport/insurancecompany',
        BULK_IMPORT_POLICY_BENEFICIARY: API_ROOT_PATH.INSURANCE_COMPANY + '/bulkimport/policybeneficiary',
        BULK_EXPORT_POLICY_BENEFICIARY: API_ROOT_PATH.INSURANCE_COMPANY + '/exporttemplate/policybeneficiary',
    },
    POLICY_AND_PRODUCT: {
        GET_LIST: API_ROOT_PATH.INSURANCE_COMPANY + '/policylist',
        GET_POLICY: API_ROOT_PATH.INSURANCE_COMPANY + '/policy', // used in delete as well
        GET_BENEFICIARY_LIST: API_ROOT_PATH.BENEFICIARY + '/beneficiarylist',
        GET_NETWORK_LIST: API_ROOT_PATH.NETWORK_PROVIDER + '/networklist',
        GET_SUBCOVERAGE_LIST: API_ROOT_PATH.INSURANCE_COMPANY + '/subcoveragelist',
        EXPORT_TEMPLATE: API_ROOT_PATH.INSURANCE_COMPANY + '/exporttemplate/policy',
        IMPORT_TEMPLATE: API_ROOT_PATH.INSURANCE_COMPANY + '/bulkimport/policy',
        UPLOAD_POLICY_ATTACHMENTS: API_ROOT_PATH.INSURANCE_COMPANY + '/policy/attachments',
        DOWNLOAD_POLICY_ATTACHMENTS: API_ROOT_PATH.INSURANCE_COMPANY + '/attachment/download'
    },
    PROVIDER: {
        PROVIDER: API_ROOT_PATH.NETWORK_PROVIDER + '/provider',
        ATTACHMENTS: API_ROOT_PATH.NETWORK_PROVIDER + '/provider/attachments',
        ATTACHMENT: API_ROOT_PATH.NETWORK_PROVIDER + '/attachment',
        DOWNLOAD: API_ROOT_PATH.NETWORK_PROVIDER + '/attachment/download',
        BULK_PROVIDER_IMPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/bulkimport/provider',
        BULK_PROVIDER_EXPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/exporttemplate/provider',
        BULK_MEDICAL_EXPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/exporttemplate/providermedicalcontact',
        BULK_MEDICAL_IMPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/bulkimport/providermedicalcontact',
        BULK_ADMINSTRATION_EXPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/exporttemplate/provideradministrationcontact',
        BULK_ADMINSTRATION_IMPORT: API_ROOT_PATH.NETWORK_PROVIDER + '/bulkimport/provideradministrationcontact',
    },
    ELIGIBILITY: {
        ELIGIBILITY: API_ROOT_PATH.ELIGIBILITY + '/eligibility',
        GENERATE_PDF: API_ROOT_PATH.ELIGIBILITY + '/generateeligibilitydocumenttopdf',
        GENERATE_UCAF: API_ROOT_PATH.ELIGIBILITY + '/generateucafdocumenttopdf',
        SEND_EMAIL: API_ROOT_PATH.ELIGIBILITY + '/sendemailwitheligibilitypdf',
        SEND_EMAIL_UCAF: API_ROOT_PATH.ELIGIBILITY + '/sendemailwithucafdocument'
    },
    DENIAL_MANAGEMENT: {
        GET_LIST: API_ROOT_PATH.APPROVAL + '/approvaldenialitemlist',
        APPROVE_DISAPPROVE_ITEMS: API_ROOT_PATH.APPROVAL + '/approvaldenialitemprocess',
        UNREAD_CLAIM: API_ROOT_PATH.APPROVAL + '/approvaldenialitem/unread/count',
        MARK_ALL_READ: API_ROOT_PATH.APPROVAL + '/approvaldenialitem/markread',
        GET_REJECTION_COUNT: API_ROOT_PATH.APPROVAL + '/approvaldenialitemsamount',
    },
    LANG_RESOURCE_JSON: API_ROOT_PATH.CONFIGURATION + "/getlanguagejsonfile",
    AUDIT_LOGS: API_ROOT_PATH.CONFIGURATION + '/auditlog',
    FAQ: {
        FAQ: API_ROOT_PATH.CONFIGURATION + '/faqlist',
        MANAGE: API_ROOT_PATH.CONFIGURATION + '/faq',
    },
    CONFIGURATION: {
        SERVICE_TYPE: {
            SERVICE_TYPE: API_ROOT_PATH.CONFIGURATION + '/servicetype',
            EXPORT_TEMPLATE: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/servicetype',
            BULK_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/servicetype'
        },
        PHYSICIAN: {
            PHYSICIAN: API_ROOT_PATH.CONFIGURATION + '/physician',
            BULK_PHYSICIAN_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/physician',
            BULK_PHYSICIAN_EXPORT: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/physician',

        },
        COMMON_LOV: API_ROOT_PATH.CONFIGURATION + '/commonlovlist',
        DIAGNOSIS: API_ROOT_PATH.CONFIGURATION + '/diagnosis',
        BODYSUBSITE: API_ROOT_PATH.CONFIGURATION + '/bodysubsite',
        BODYSITE: API_ROOT_PATH.CONFIGURATION + '/bodysite',
        LOINC_CODE: {
            LOINC_CODE_LIST: API_ROOT_PATH.CONFIGURATION + '/loinccodelist',
            LOINC_CODE: API_ROOT_PATH.CONFIGURATION + '/loinccode',
            BULK_LOINC_CODE_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/loinccode'
        },
        CLAIM_TYPE: {
            CLAIM_TYPE_LIST: API_ROOT_PATH.CONFIGURATION + '/claimtypelist',
            MANAGE_CLAIM_TYPE: API_ROOT_PATH.CONFIGURATION + '/claimtype',
            IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/claimtype',
            EXPORT: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/claimtype'
        },
        SPECIALITY: {
            SPECIALITY: API_ROOT_PATH.CONFIGURATION + '/speciality',
            BULK_IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/speciality'
        },
        REASONS: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/reasonlist',
            MANAGE: API_ROOT_PATH.CONFIGURATION + '/reason',
            IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/reason',
            EXPORT: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/reason'
        },
        ENCOUNTER_CLASS: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/encounterclasslist',
            MANAGE: API_ROOT_PATH.CONFIGURATION + '/encounterclass',
            IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/encounterclass'
        },
        MORPHOLOGY: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/morphologylist',
            MANAGE: API_ROOT_PATH.CONFIGURATION + '/morphology',
            IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/morphology',
            EXPORT: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/morphology'
        },
        DOSAGE: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/dosagetypelist',
            MANAGE: API_ROOT_PATH.CONFIGURATION + '/dosagetype',
            IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/dosagetype',
            EXPORT: API_ROOT_PATH.CONFIGURATION + '/exporttemplate/dosagetype'
        },

        PHARMACEUTICAL_FORM: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/pharmaceuticalformlist',
            MANAGE: API_ROOT_PATH.CONFIGURATION + '/pharmaceuticalform'
        },
        DOSAGE_TYPE: {
            LIST: API_ROOT_PATH.CONFIGURATION + '/dosagetypelist',
            MANAGE: API_ROOT_PATH.CONFIGURATION + '/dosagetype',
        },
        UCUM_CODE: {
            UCUM_CODE: API_ROOT_PATH.CONFIGURATION + '/ucumcode',
            IMPORT: API_ROOT_PATH.CONFIGURATION + '/bulkimport/ucumcode'
        },
        SYSTEM_SETTINGS: API_ROOT_PATH.CONFIGURATION + '/systemsetting',
        USER_SETTINGS: API_ROOT_PATH.CONFIGURATION + '/usersetting',
        USER_CHART_SETTINGS: API_ROOT_PATH.CONFIGURATION + '/userchartsetting',
        CHART_SETTINGS: API_ROOT_PATH.CONFIGURATION + '/chartsetting',
        PAYER_MASTER_SETTINGS: API_ROOT_PATH.CONFIGURATION + '/payermastersetting',
        PAYER_SETTINGS: API_ROOT_PATH.CONFIGURATION + '/payersetting',
        PAYER_PROVIDER_SETTING: API_ROOT_PATH.CONFIGURATION + '/payerprovidersetting',
        PAYER_PROVIDER_SETTINGS_LIST: API_ROOT_PATH.CONFIGURATION + '/payerprovidersettingslist',
        DASHBOARD_LAYOUT: API_ROOT_PATH.CONFIGURATION + '/chartlayout',
    },
    PAYMENT: {
        LIST: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentlist',
        PAYMENT: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/payment',
        TRANSACTION: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymenttransaction',
        RECONCILIATION_TRANSACTION: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/reconciliationpayment',
        PAYMENT_AGREE: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/agreeforpayment',
        PROCESSED_CLAIM_LIST: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/processedclaimlist',
        RECONCILIATION_LIST: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentreconciliationlist',
        PAYMENT_BY_CLAIM: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/paymentdetailsbyclaim',
        MARK_ALL_READ: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/payment/markread',
        UNREAD: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/payment/unread/count',
        GENERATE_PDF: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/generatepaymentdocumenttopdf',
        SEND_EMAIL: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/sendemailwithpaymentpdf',
        SEND_NOTICE: API_ROOT_PATH.PAYMENT_RECONCILIATION + '/sendnoticeforpayment'
    },
    AUTHENTICATION: {
        LOGIN: API_ROOT_PATH.AUTHENTICATION + '/login',
        LOGOUT: API_ROOT_PATH.AUTHENTICATION + '/logout',
        REFRESH_TOKEN: API_ROOT_PATH.AUTHENTICATION + '/refreshToken',
        FORGOT_PASS_SEND_MAIL: API_ROOT_PATH.AUTHENTICATION + '/forgotpassword/sendemail',
        VALIDATE_RESET_PASS: API_ROOT_PATH.AUTHENTICATION + '/resetpassword/validate',
        RESET_PASSWORD: API_ROOT_PATH.AUTHENTICATION + '/resetpassword',
        PATIENT_LOGIN: API_ROOT_PATH.AUTHENTICATION + '/patient/login',
        PATIENT_SEND_OTP: API_ROOT_PATH.AUTHENTICATION + '/patient/sendotp',
        DEFAULT_SETTING: API_ROOT_PATH.AUTHENTICATION + '/defaultsystemsettings',
    },
    COMMON: {
        GET_ALL_USERS: API_ROOT_PATH.COMMON + '/users',
        GET_USERS_BY_PERMISSION: API_ROOT_PATH.COMMON + '/usersbypermission',
        USER: API_ROOT_PATH.COMMON + '/user',
        RESET_PASSWORD: API_ROOT_PATH.COMMON + '/resetpassword',
        ROLES: 'common/role',
        PERMISSIONS: 'common/permissions',
        DASHBOARD_SUMMARY: API_ROOT_PATH.COMMON + '/dashboardsummary',
        DASHBOARD_SUMMARY_DOWNLOAD: API_ROOT_PATH.COMMON + '/dashboardsummary/download',
        REPORT_SUMMARY: API_ROOT_PATH.COMMON + '/reportsummary',
        REPORT_SUMMARY_DOWNLOAD: API_ROOT_PATH.COMMON + '/reportsummary/download',
        SESSION_LIST: API_ROOT_PATH.COMMON + '/usersessionlist',
        USER_ACTIVITY: API_ROOT_PATH.COMMON + '/useractivity',
        ASSIGNED_USER: API_ROOT_PATH.COMMON + '/userswithroles',
        PATIENT_DASHBOARD_SUMMARY: API_ROOT_PATH.COMMON + '/patientdashboardsummary',
        DEFAULT_ROLE_PERMISSION: API_ROOT_PATH.COMMON + '/defaultrolepermission',
        USER_WITH_HIGH_COST: API_ROOT_PATH.COMMON + '/userswithhighcostpermission'
    },
    NPHIES: {
        GET_REQUEST_RESPONSE_JSON: API_ROOT_PATH.NPHIES + '/nphiesrequestresponsejson'
    },
    SUPERSET: {
        CHART_LIST: API_ROOT_PATH.CONFIGURATION + '/supersetchartlist',
        GUEST_TOKEN: API_ROOT_PATH.CONFIGURATION + '/supersetguesttoken',
        GUEST_TOKEN_FOR_CHART: API_ROOT_PATH.CONFIGURATION + '/supersetguesttokenforchart',
    }
};
